import { signIn as cognitoSignin, confirmSignIn } from "aws-amplify/auth";

export async function signInMfa(
  email: string | null,
  password: string | null,
  code?: string,
  trust2fa?: string | null,
): Promise<void> {
  if (!email || !password) {
    throw new Error("Something went wrong while signing in");
  }

  const { isSignedIn } = await cognitoSignin({
    username: email,
    options: {
      authFlowType: "CUSTOM_WITHOUT_SRP",
    },
  });

  if (isSignedIn) {
    return;
  }

  const answer = await confirmSignIn({
    challengeResponse: JSON.stringify({
      password: password,
      code: code,
      trust_2fa: trust2fa,
    }),
    options: {
      clientMetadata: {
        authType: "PASSWORD",
      },
    },
  });

  if (!answer.isSignedIn) {
    throw new Error("Something went wrong while signing in");
  }
}
